import { render, staticRenderFns } from "./concernManage.vue?vue&type=template&id=487d62c6"
import script from "./concernManage.vue?vue&type=script&lang=js"
export * from "./concernManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports